/**
 * Canonical API base URL for the Facilitator Portal.
 *
 * Why this exists (Fuad's round-2 catch, 2026-06-13): yesterday's fix
 * mistakenly thought relative baseURLs would proxy correctly in
 * Docker. In dev they do (Vite proxies `/api/*` → :8000). In Docker
 * they don't (different container, no proxy), and every axios call
 * lands on the FP's own origin and 404s.
 *
 * Resolution order:
 *   1. VITE_API_BASE_URL set at build / runtime (Docker env)
 *   2. Empty string → relative URLs, picked up by Vite proxy in dev
 *      or whatever reverse proxy is in front of the FP in prod
 *
 * Same shape CC + web already use; keeps the deployment story aligned.
 */
/**
 * The drill server's WebSocket origin, from the same base as the API calls
 * (2 Oct drill: the console used Studio's own host, and when Studio's proxy
 * stopped forwarding /api/ the drill room silently lost its connection).
 * Falls back to this page's host only when no API base is configured (dev).
 */
export function wsOrigin(): string {
  const base = API_BASE_URL.replace(/\/+$/, '');
  if (/^https?:\/\//.test(base)) return base.replace(/^http/, 'ws');
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}${base}`;
}

export const API_BASE_URL: string =
   
  (import.meta as any).env?.VITE_API_BASE_URL ?? '';
